import BaseApiService from './api.base.service'

class JournalsApiService extends BaseApiService {
  constructor() {
    super('journals')
  }

  getJournalsSubscriptionsOdata(params) {
    return this.callGet(`/subscriptions/odata`, params)
  }
  getJournalsSubscriptionsAggregatedOdata(params) {
    return this.callGet(`/subscriptions/aggregated-odata`, params)
  }

  openJournalbyRowId(rowId) {
    return this.callPost(`subscriptions/${rowId}/redirect`)
  }

  activateJournalSubscriptions(productActivationId, permissions) {
    return this.callPost('/activate', {
      id: productActivationId,
      permissions: permissions,
    })
  }

  getNamesOfJournalsToActiveteByProductActivationId(productActivationId) {
    return this.callGet(`${productActivationId}/to-activate/names`)
  }

  allJournalSubscriptionsActive(productActivationId, clientId) {
    return this.callGet(`${productActivationId}/clients/${clientId}/active`)
  }

  allJournalActivationDataForCrmPresent(productActivationId) {
    return this.callGet(`${productActivationId}/crm/present`)
  }

  activateOrUpdateJournalSubscriptions(
    productActivationId,
    clientId,
    permissions
  ) {
    return this.callPost('/activate', {
      id: productActivationId,
      clientId: clientId,
      permissions: permissions,
    })
  }
}

export const journalsApi = new JournalsApiService()
